import { render, staticRenderFns } from "./HelpFileFormat.vue?vue&type=template&id=6c4c8836"
import script from "./HelpFileFormat.vue?vue&type=script&lang=js"
export * from "./HelpFileFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports